$(document).ready(function() {
  radioChecked()
  updateLabelCheckedRadio()
})


function radioChecked() {
  $('.radioCheked').unbind('click');

  const countryPopupId = "#country-select-popup";
  const statePopupId   = "#state-select-popup";
  const cityPopupId    = "#city-select-popup";

  $('.radioCheked').click(function(e) {
    var id    = $(this).val();
    var model = $(this).closest('.list-unstyled').attr('data-model');

    const parent = e.currentTarget.closest('.popup-wrapper');
    parent.classList.remove('show');

    if (model == 'Country') {
      // remove popup country & state
      var countryPopup = $(`.form-overlay[data-popup="${countryPopupId}"]`);
      countryPopup.removeAttr('data-popup');

      var statePopup = $(`.form-overlay[data-popup="${statePopupId}"]`);
      statePopup.removeAttr('data-popup');

      $("#target-select-option-State").text('Loading....');
    }

    if (model == 'State') {
      // remove popup state & city
      var statePopup = $(`.form-overlay[data-popup="${statePopupId}"]`);
      statePopup.removeAttr('data-popup');

      var cityPopup = $(`.form-overlay[data-popup="${cityPopupId}"]`);
      cityPopup.removeAttr('data-popup');

      $("#target-select-option-City").text('Loading....');
    }

    $.ajax({
      url: '/user/addresses/get_data_collection',
      method: 'get',
      data: { 'id': id, 'model': model },
      dataType: 'json',
      success: function(res) {
        var html = '';

        $.each(res.data.data_body, function(index, value) {
          html += setSelecOption(value, res.data)
        })

        $(`#${res.select_target}`).html(html)
        selectOptionText();
        radioChecked()

        if (model == 'State') {
          updateLabelSelectOption($(`#${res.select_target}`));

          // Add popup country & state
          statePopup.attr('data-popup', statePopupId);
          cityPopup.attr('data-popup', cityPopupId);
        }

        if (model == 'Country') {
          $('#target-city-select').html('')
          updateLabelSelectOption($('#target-state-select'));
          updateLabelSelectOption($('#target-city-select'));

          // Add popup country & state
          countryPopup.attr('data-popup', countryPopupId);
          statePopup.attr('data-popup', statePopupId)
        }
      },
      error: (err, status) => {
        console.log('FAILED!')
      }
    });
  })
}

function setSelecOption(option, popup) {
  var options = `<label for='${popup.field_name}-${option.id}' class="border-bottom border-gray py-2 d-flex">`+
                  `<li class='list-select-option' data-value='${option.label}' data-label='${option.label}' data-description='${option.label}' style="width: -webkit-fill-available;">`+
                    `<div class="label-left border-grey w-100 d-flex justify-content-between">`+
                      `<div class="label-item">`+
                        `<span class="fs-12 mt-1" >`+
                          `${option.label}`+
                        `</span>`+
                      `</div>`+
                      `<div class="check-item">`+
                        `<div class="form-check me-1">`+
                          `<input type='radio' name='address[${popup.field_name}]' id='${popup.field_name}-${option.id}' value='${option.id}' class='form-check-input form-radio radioCheked radioSelectOption'>`+
                        `</div>`+
                      `</div>`+
                    `</div>`+
                  `</li>`+
                `</label>`;
  return options
}

function updateLabelCheckedRadio() {
  $.each($('input[type=radio]:checked'), function() {
    prosesSelectOptionText($(this))
  })
}

// function prosesSelectOptionText($radio) {
//   var radio_id             = $radio.attr('id');
//   var parent_select_option = $radio.closest('.parentSelectOption');
//   var target_select_option = parent_select_option.attr('data-target-select-option');
//   var label_text           = $(`label[for='${radio_id}']`).find('span').text();

//   $(`#${target_select_option}`).html(label_text);
// }